import { render, staticRenderFns } from "./yongyao.vue?vue&type=template&id=2b25ae68&scoped=true&"
import script from "./yongyao.vue?vue&type=script&lang=ts&"
export * from "./yongyao.vue?vue&type=script&lang=ts&"
import style0 from "./yongyao.vue?vue&type=style&index=0&id=2b25ae68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b25ae68",
  null
  
)

export default component.exports